module.exports = __webpack_public_path__ + "static/img/8.960f256.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/8.jpg
// module id = of7W
// module chunks = 1